import $ from 'jquery';
window.jQuery = window.$ = $;

import '@progress/kendo-ui/js/kendo.window';
import '@progress/kendo-theme-default/dist/all.css';
import { WindowInstaller } from '@progress/kendo-window-vue-wrapper';

export default WindowInstaller;
